import { Action } from 'redux';
import { Design } from '@/types';

export interface DesignsState {
  detail: Record<string, Design>;
  favorites: string[];
}

export enum DesignsActionTypes {
  DESIGNS_FETCH = '@designs/fetch',
  TOGGLE_FAVORITE = '@designs/toggle-favorite',
  UPDATE_FAVORITE = '@designs/update-favorite',
}

export interface DesignsFetchAction extends Action {
  type: DesignsActionTypes.DESIGNS_FETCH;
  payload: Design;
}

export interface DesignToggleFavoriteAction extends Action {
  type: DesignsActionTypes.TOGGLE_FAVORITE;
  designId: string;
}

export interface DesignUpdateFavoriteAction extends Action {
  type: DesignsActionTypes.UPDATE_FAVORITE;
  deprecatedDesignId: string;
  designId: string;
}

export type DesignsActions =
  | DesignsFetchAction
  | DesignToggleFavoriteAction
  | DesignUpdateFavoriteAction;
